import { DeleteTwoTone } from "@ant-design/icons";
import { SINGLETON_ITEM } from "@p0security/shared/install/constants";
import { InstallSpec, ItemComponent } from "@p0security/shared/install/types";
import { IntegrationStatus } from "@p0security/shared/integrations/shared";
import { Button, Typography } from "antd";
import { useCallback } from "react";

import { ComponentProps } from "./Component";
import { Config } from "./Config";

const { Paragraph } = Typography;

export type SingletonProps<T extends InstallSpec> = ComponentProps<T> & {
  component: ItemComponent<any>;
  onItemStateChange?: (state: IntegrationStatus) => void;
};

export const Singleton = <T extends InstallSpec>(props: SingletonProps<T>) => {
  const {
    authFetch,
    config,
    component,
    componentKey,
    integration,
    onItemStateChange,
  } = props;
  const item = config[componentKey]?.[SINGLETON_ITEM];
  const path = `integrations/${integration}/config/${componentKey}/${SINGLETON_ITEM}`;

  const uninstall = useCallback(async () => {
    await authFetch(path, { method: "DELETE" });
  }, [authFetch, path]);

  const stage = useCallback(async () => {
    await authFetch(path, { method: "PUT", json: {} });
  }, [authFetch, path]);

  return item ? (
    <>
      <Config
        {...props}
        item={item}
        id={SINGLETON_ITEM}
        onItemStateChange={onItemStateChange}
      />
      {component.type === "singleton" && (
        <Button icon={<DeleteTwoTone />} onClick={uninstall}>
          Uninstall
        </Button>
      )}
    </>
  ) : (
    <>
      <Paragraph>To continue, click &quot;Install&quot;</Paragraph>
      <Button type="primary" onClick={stage}>
        Install
      </Button>
    </>
  );
};
